module.exports = __webpack_public_path__ + "static/1-2bfb50302d0e5a8ce083a0c21ca7db41.jpeg";